import React, { useState, useEffect } from "react";
import { getProfile } from "../services/profile";
import { useAuth } from "../context/AuthContext";
import {
  MdOutlineChat,
  MdOutlineSmartToy,
  MdOutlineSchedule,
  MdChat,
  MdSmartToy,
  MdSchedule,
  MdPerson,
  MdLogout
} from "react-icons/md";

import { TfiTicket } from "react-icons/tfi";
import { RiMenuUnfold2Line, RiMenuUnfoldLine } from "react-icons/ri";


import { styles } from "../styles/Menu.styles";
import { useNavigate, useLocation } from "react-router-dom";

const Menu = ({ isMobile, onLogout }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoveredLogout, setHoveredLogout] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [profile, setProfile] = useState(null);
  const { token, setToken, setStampTomador } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
      {
        icon: MdOutlineChat,
        iconFilled: MdChat,
        text: "Conversas",
        path: "/conversas",
      },
      {
        icon: MdOutlineSmartToy,
        iconFilled: MdSmartToy,
        text: "AIs",
        path: "/ais",
      },
      {
        icon: MdOutlineSchedule,
        iconFilled: MdSchedule,
        text: "Agendar",
        path: "/agendar",
      },
      {
        icon: TfiTicket,
        iconFilled: TfiTicket,
        text: "Tickets",
        path: "/tickets",
      },
  ];

  useEffect(() => {
    const loadProfile = async () => {
      if (!token) return;
      try {
        const data = await getProfile();
        if (data) setProfile(data);
      } catch (error) {
        console.error("Erro ao carregar perfil:", error);
      }
    };

    loadProfile();
  }, [token]);

  return (
    <div
      style={{
        ...styles.container(isMobile),
        width: isMobile ? "100%" : isExpanded ? "240px" : "80px",
        transition: "width 0.45s cubic-bezier(0.22, 1, 0.36, 1)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {!isMobile && (
        <div style={styles.brand(isExpanded)}>
          <img
            src="/gemeseicon.png"
            alt="Gemese"
            title="Gemese"
            style={styles.brandImage(isExpanded)}
          />
          <span style={styles.brandName(isExpanded)}>
            <span style={styles.brandTitle}>Gemese</span>
            <span style={styles.brandSubtitle}>Chat</span>
          </span>
          <button
            type="button"
            aria-label={isExpanded ? "Recolher menu" : "Expandir menu"}
            title={isExpanded ? "Recolher menu" : "Expandir menu"}
            onClick={() => setIsExpanded((expanded) => !expanded)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "auto",
              width: isExpanded ? 36 : 30,
              height: isExpanded ? 36 : 30,
              border: "1px solid #E5E7EB",
              borderRadius: 9,
              background: "#FFFFFF",
              color: "#1F3A70",
              cursor: "pointer",
            }}
          >
            {isExpanded ? <RiMenuUnfold2Line size={22} /> : <RiMenuUnfoldLine size={18} />}
          </button>
        </div>
      )}
      {/* USER SECTION - TOP */}
      {!isMobile && (
        <div
          style={{
            ...styles.userWrapper(isExpanded),
            paddingBottom: 16,
            marginBottom: 12,
            borderBottom: "1px solid #E5E7EB",
          }}
        >
          <div style={styles.userAvatar}>
            {profile?.FOTO ? (
              <img
                src={profile.FOTO}
                alt="User"
                style={styles.userImage}
              />
            ) : (
              <MdPerson size={28} color="#6B7280" />
            )}
          </div>

          <div style={styles.userInfo}>
            <span style={styles.userName}>
              {profile?.NOME || "Utilizador"}
            </span>
            <span style={styles.userRole}>
              Online
            </span>
          </div>
        </div>
      )}

      {/* MENU ITEMS */}
      <ul
        style={{
          ...styles.ul(isMobile),
          flex: 1,
          display: "flex"
          
        }}
      >
        {menuItems.map((item) => {
          const isActive = location.pathname.startsWith(item.path);

          const isHovered = hoveredItem === item.text;
          const IconComponent = isActive ? item.iconFilled : item.icon;

          return (
            <li
              key={item.text}
              style={{
                ...styles.li(isMobile, isActive, isHovered),
                justifyContent: isMobile ? "center" : isExpanded ? "flex-start" : "center",
                width: isMobile ? "auto" : "100%",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "visible",
              }}
              onClick={() => navigate(item.path)}
              onMouseEnter={() => setHoveredItem(item.text)}
              onMouseLeave={() => setHoveredItem(null)}
              role="button"
              tabIndex={0}
              aria-current={isActive ? "page" : undefined}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  navigate(item.path);
                }
              }}
            >
              <span style={styles.icon(isActive, isHovered)}>
                <IconComponent />
              </span>

              {!isMobile ? (
                <span
                  style={styles.menuLabel(isExpanded, isActive)}
                >
                  {item.text}
                </span>
              ) : (
                <span style={styles.mobileMenuLabel(isActive)}>{item.text}</span>
              )}
              {!isMobile && !isExpanded && isHovered && (
                <span style={styles.tooltip}>{item.text}</span>
              )}
            </li>
          );
        })}
        {/* LOGOUT as part of the menu items */}
        <li
       style={{
              ...styles.li(isMobile, false, hoveredLogout),
        justifyContent: isMobile ? "center" : isExpanded ? "flex-start" : "center",
        width: isMobile ? "auto" : "100%",
              transition: "all 0.3s ease",
              position: "relative",
              overflow: "visible",
              marginTop: isMobile ? 0 : "auto",
              marginBottom: isMobile ? 0 : 28,
              paddingBottom: isMobile ? 0 : 6,
            }}
          onClick={() => {
            setToken(null);
            setStampTomador(null);
            onLogout?.();
          }}
          onMouseEnter={() => setHoveredLogout(true)}
          onMouseLeave={() => setHoveredLogout(false)}
          role="button"
          tabIndex={0}
          aria-label="Sair"
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              setToken(null);
              setStampTomador(null);
              onLogout?.();
            }
          }}
        >
          <span style={styles.icon(false, hoveredLogout)}>
            <MdLogout />
          </span>

          {!isMobile ? (
            <span
              style={styles.menuLabel(isExpanded, false)}
            >
              Logout
            </span>
          ) : (
            <span style={styles.mobileMenuLabel(false)}>Sair</span>
          )}
          {!isMobile && !isExpanded && hoveredLogout && (
            <span style={styles.tooltip}>Logout</span>
          )}
        </li>
      </ul>
    </div>
  );
};

export default Menu;